// Vendors
import $ from 'jquery';

// Toggle mobile nav
$('[data-toggle="nav-mobile"]').on('click', (event) => {
  event.preventDefault();
  $(event.currentTarget).toggleClass('hamburger--active');
  $('.mobile-nav').toggleClass('mobile-nav--visible');
  $('.mobile-nav').removeAttr('style');
  $('.mobile-nav').scrollTop(0);
  $('body').toggleClass('nav-mobile-is-visible');
  $('html').toggleClass('nav-mobile-is-visible');
});

// Toggle nested menu items
$('.mobile-nav .caret').on('click', (event) => {
  event.preventDefault();
  const $this = $(event.currentTarget);
  if (!$this.siblings('.sub-menu').hasClass('sub-menu--visible')) {
    $this.siblings('.sub-menu').addClass('sub-menu--visible');
    $this
      .removeClass('caret--down sub-menu--closed')
      .addClass('caret--up sub-menu--open');
  } else {
    $this.siblings('.sub-menu').removeClass('sub-menu--visible');
    $this
      .removeClass('caret--up sub-menu--open')
      .addClass('caret--down sub-menu--closed');
  }
});

// Add .btn CSS class to <a> instead of <li>
const $listItem = $('#menu-mobile-navigation .sub-menu li.btn');

if ($listItem) {
  $listItem.removeClass('btn');
  $listItem.children('a').addClass('btn');
}

// Mobile user avatar click opens menu
const $avatar = $('#mobile-user-avatar');

if ($avatar) {
  $avatar.on('click', (event) => {
    event.preventDefault();
    $('.mobile-header .hamburger').trigger('click');
    $('#menu-mobile-navigation .my-account .caret').trigger('click');
  });
}
